export default __webpack_public_path__ + "static/media/ham_menu.d6d7095e.svg";